<template>
    <router-link :to="to" class="link uni-caption">
        <slot/>
    </router-link>
</template>

<script>
    export default {
        name: "UniLink",
        props: {
            to: {
                type: Object,
                default: {name: 'home'},
            }
        }
    }
</script>

<style scoped lang="scss">
    .link{
        border-radius: var(--radius-default);
        padding: 6px;
        color: var(--color-primary);
        text-align: center;
        height: 32px;
        text-transform: uppercase;
        line-height: 20px;
    }
</style>
